import React from "react";
import DatePicker from "react-datepicker";
import moment from "moment";
import { RevvForm } from "../../../../commonComponents";

import {
  CustomFieldComponentRules,
  CustomFieldComponentMessages,
} from "../../DynamicField/DynamicFieldComponents/CustomFieldRulesMap";

export default class DateFieldFormMode extends React.Component {
  state = {
    dateFieldValues: {
      default: JSON.parse(JSON.stringify(this.props.initialProps.value)),
    },
  };

  _handleOnChange = (value, handleChangeByName) => {
    handleChangeByName(value, "default");
    // If there is a value then only
    // make an API call and update the redux store
    if (value) {
      const { id, meta } = this.props.initialProps;
      const currentDate = moment(value).format(meta.format.toUpperCase());
      this.props._updateDynamicFieldsInDoc(id, currentDate);
      this._checkForUpdateField(currentDate);
    } else {
      const { id } = this.props.initialProps;
      this.props._updateDynamicFieldsInDoc(id, null);
      this._checkForUpdateField(null);
    }
  };

  _checkForUpdateField = currentValue => {
    const { id, value: initialValue } = this.props.initialProps;
    if (initialValue !== currentValue) {
      this.props._updateField(id, currentValue);
      this.props.filledStatus(currentValue !== null);
    }
  };

  render() {
    const { id, /* docIsLocked */ meta } = this.props.initialProps;
    return (
      <React.Fragment>
        <RevvForm
          revvFormId={id}
          initialFormValue={this.state.dateFieldValues}
          customFieldName="DTAE"
          customFieldComponentRules={CustomFieldComponentRules}
          customFieldComponentMessages={CustomFieldComponentMessages}
          render={formProps => {
            const { handleChangeByName, values } = formProps;
            return (
              <React.Fragment>
                <DatePicker
                  className="form-control"
                  selected={
                    values.default !== null && values.default !== "Invalid date"
                      ? moment(
                          values.default,
                          meta.format && meta.format.toUpperCase(),
                        )
                      : ""
                  }
                  onChange={date =>
                    this._handleOnChange(date, handleChangeByName)
                  }
                  dateFormat={meta.format && meta.format.toUpperCase()}
                  disabled={this.props.isLocked}
                  autoFocus
                  data-test="date-form-mode-test"
                />
              </React.Fragment>
            );
          }}
        />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DocumentV2/FormView/FormModeComponents/DateFieldFormMode.js